import { client as v1Client } from './v1/client.gen';
import { client as v2Client } from './v2/client.gen';
import { replaceTypesInDataStructure } from '../utils/Helpers';
import { GOADate } from '../utils/date/GOADate';

let configured = false;

const getBaseUrl = () =>
  typeof window === 'undefined' ? undefined : `${window.location.protocol}//${window.location.host}`;

const toLegacyError = (error: unknown, response?: Response) => ({
  res: {
    data: error,
    status: response?.status,
  },
});

const serializeQuery = (query: Record<string, unknown> = {}) => {
  const params: string[] = [];

  Object.entries(query).forEach(([name, value]) => {
    if (value === undefined || value === null) return;

    const values = Array.isArray(value) ? value : [value];
    values.forEach((item) => {
      const serializedValue = item instanceof GOADate ? item.toJSON() : item;
      params.push(`${encodeURIComponent(name)}=${encodeURIComponent(String(serializedValue))}`);
    });
  });

  return params.join('&');
};

export const configureOpenApiClients = () => {
  if (configured) return;

  const config = {
    baseUrl: getBaseUrl(),
    throwOnError: true,
    querySerializer: serializeQuery,
    responseTransformer: replaceTypesInDataStructure,
  };

  [v1Client, v2Client].forEach((client) => {
    client.setConfig(config);
    client.interceptors.error.use(toLegacyError);
  });

  configured = true;
};
